// extracted by mini-css-extract-plugin
export default {"label":"form-select_label__7ax5u","select":"form-select_select__0PpCC","error":"form-select_error__O3X43","error-message":"form-select_error-message__+riPt"};